export default "__VITE_ASSET__CQU1WIvY__"